export interface IStatisticTotalItem {
  percent: number;
  total: number;
  direction: StatisticTotalItemDirection;
}

export type StatisticTotalItemDirection = "up" | "down" | "neutral";

export interface IGymsStatistic {
  name: "Approved" | "UnderReview" | "Declined";
  value: number;
  color: string;
}

export interface IUsersStatistics {
  name: "Active" | "Inactive" | "Deleted" | "Trial";
  value: number;
  color: string;
}

export interface ISummaryStatistics {
  totalRevenues: IStatisticTotalItem;
  totalVisitors: IStatisticTotalItem;
  newSignUps: IStatisticTotalItem;
  gyms: IGymsStatistic[];
  users: IUsersStatistics[];
}

export enum StatsRevenuePeriodsEnum {
  YEAR = "year",
  HALF_YEAR = "half_year",
  MONTH = "month",
  WEEK = "week",
}

export interface IRevenueStatistics {
  name: string;
  uv: number;
}
